export default __webpack_public_path__ + "static/media/alimentacao.19a0b5a4.png";